import { createSlice } from "@reduxjs/toolkit";

export const asyncDataReducer = createSlice({
  name: "asyncData",
  initialState: {
    isLoading: false,
    isError: false,
    message: "",
    data: [],
  },
  reducers: {
    LOADING: (state) => {
      return { ...state, isLoading: true, isError: false };
    },
    SUCCESS: (state) => {
      return { ...state, isLoading: false, isError: false };
    },
    FAIL: (state) => {
      return { ...state, isLoading: false, isError: true };
    },
  },
});

// Action creators are generated for each case reducer function
export const { LOADING, SUCCESS, FAIL } = asyncDataReducer.actions;

export default asyncDataReducer.reducer;
